const locationRoutes = {
  path: '/:channelId/locations/:locationId',
  name: 'locations-location',
  components: {
    default: () => import('@/views/PageLocationRoutView.vue')
  },
  redirect: { name: 'locations-location-detail' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '',
      name: 'locations-location-detail',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'locationDetail' }
    },
    {
      path: 'settings',
      name: 'locations-location-settings',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'settings' }
    },
    {
      path: 'openinghours',
      name: 'locations-location-openinghours',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'openingHours' }
    },
    {
      path: 'description',
      name: 'locations-location-description',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'description' }
    },
    {
      path: 'images',
      name: 'locations-location-images',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'images' }
    },
    {
      path: 'videos',
      name: 'locations-location-videos',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'videos' }
    },
    {
      path: 'accounts',
      name: 'locations-location-accounts',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'accounts' }
    },

    {
      path: 'options',
      name: 'locations-location-options',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'options' }
    },

    {
      path: 'options/:optionId',
      name: 'locations-location-options-detail',
      component: () => import('@/components/Options/OptionDetail'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'options-optionDetail' }
    },

    {
      path: 'spaces',
      name: 'locations-location-spaces',
      component: () => import('@/views/Locations/LocationController.vue'),
      props: { pageView: 'spaces' },
      children: [
        {
          path: ':spaceId',
          name: 'locations-location-spaces-detail',
          component: () => import('@/components/Locations/Manage/Spaces/SpaceDetail.vue'),
        },
      ]
    },

    {
      path: 'vouchers',
      name: 'locations-location-vouchers',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'vouchers' }
    },

    {
      path: 'vouchers/:voucherId',
      name: 'locations-location-vouchers-detail',
      component: () => import('@/views/Vouchers/VoucherDetail'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'vouchers' }
    },

    {
      path: 'yield',
      name: 'locations-location-yield',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'yield' }
    },

    {
      path: 'yield/:yieldId',
      name: 'locations-location-yield-detail',
      component: () => import('@/components/Yield/YieldDetail'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'yield' }
    },

    {
      path: 'subscriptions',
      name: 'locations-location-subscriptions',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'subscriptions' }
    },

    {
      path: '',
      name: 'locations-location-detail',
      component: () => import('@/views/Locations/LocationController.vue'),
      meta: {
        requiresAuth: true
      },
      props: { pageView: 'locationDetail' }
    },
  ]
}

export default locationRoutes
